import React, { useState } from "react";

import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import opacity from "react-element-popper/animations/opacity"

// styles 
import styles from "./ReminderPortal.module.css"

const ReminderPortalDatePicker = (props) => {
    const [openMenu, setOpenMenu] = useState(false);

    const handleChange = async (value) => {
        //تغییرات روی تاریخ رو اینجا اعمال کنید
        if (props.addCall) {
            props.setData((prev) => {
                return { ...prev, callDate: value };
            });
            if (openMenu === true) {
                setOpenMenu(false)
            }
        } else {
            props.setData((prev) => {
                return { ...prev, dateValue: value };
            });
            if (openMenu === true) {
                setOpenMenu(false)
            }
        }
        // const userDate = `${value.year}-${value.month.number}-${value.day}`
        // console.log(userDate)
        // const userDate = await `${value.year}-${value.month.number}-${value.day} ${value.hour}:${value.minute}:${value.second}`
    }

    return (
        <>
            <style type="text/css">
                {`
                .rmdp-container {
                    width: 348px;
                    height: 48px !important;
                    background: #F9F9F9;
                    border: 1px solid #E1E1E1;
                    border-radius: 24px;
                    display: flex !important;
                    align-items: center;
                    justify-content: start;
                    padding-right: 27px;
                    cursor: pointer;
                }
    
                .rmdp-wrapper {
                    width: 348px;
                    background: #F9F9F9 !important;
                    border: 1px solid #E1E1E1 !important;
                    border-radius: 24px !important;
                    box-shadow: none !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .rmdp-input,
                .rmdp-input:focus {
                    width: 100%;
                    background: transparent;
                    border: none !important;
                    cursor: pointer !important;
                    box-shadow: none !important;
                }

                rmdp-top-class {
                    display: flex;
                    width: 100%;
                    align-items: center;
                    justify-content: center;
                }
                
                .rmdp-calendar {
                    width: 100%;
                }
                
                .rmdp-day-picker {
                    justify-content: center;
                }
                
                .rmdp-week, .rmdp-ym {
                    width: 348px;
                    padding: 0 27px;
                }

                @media only screen and (max-width: 768px) {
                    .rmdp-container { 
                        width: 100%;
                    }
                    .rmdp-wrapper {
                        width: 100%;
                    }
                    
                    .rmdp-week, .rmdp-ym {
                        width: 100%;
                    }
                }
    `}
            </style>


            <div className={`d-flex align-items-start justify-content-center flex-column my-3 mx-2 ${styles.input_container1}`}>
                <div className={`mb-2 ${styles.input_top_title}`}>
                    انتخاب روز
                </div>
                <DatePicker
                    value={props.data}
                    onChange={handleChange}
                    animations={[opacity()]}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-center"
                />
            </div>
        </>
    );
};

export default ReminderPortalDatePicker;